import classNames from 'classnames';

import styles from './Input.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  innerRef?: React.Ref<HTMLInputElement>;
  isStatic?: boolean;
}

const Input: React.FC<Props> = ({
  innerRef,
  isStatic = false,
  className,
  ...attrs
}) => (
  <input
    ref={innerRef}
    className={classNames(
      styles.input,
      {
        [styles.isStatic]: isStatic,
      },
      className,
    )}
    {...attrs}
  />
);

export default Input;
